import { OTHER_DOMAIN, SAT_PREP_COURSE } from '@/queries/constants'

const COURSE_SLUG_TO_HEADER: Record<string, () => React.ReactNode> = {
  ap: () => (
    <>
      AP<sup>&#174;</sup> Review
    </>
  ),
  geometry: () =>
    'Get Free Online Geometry Tutoring and Help—Ace Your Exams, Master Tough Concepts',
  statistics: () => 'Get Free Statistics Tutoring Online',
  algebra: () => 'Free Algebra 1 Tutoring',
  algebra2: () => 'Free Algebra 2 Tutoring',
}

export default function CourseNameHeader({
  courseName,
  courseSlug,
  domain,
  hideSuperscript = false,
  isSubheader = false,
}: {
  courseName: string | null
  courseSlug: string | null
  domain: string | null
  hideSuperscript?: boolean
  isSubheader?: boolean
}): React.ReactNode {
  if (courseSlug == null || courseName == null) {
    return 'All Courses'
  }
  if (courseSlug in COURSE_SLUG_TO_HEADER) {
    return COURSE_SLUG_TO_HEADER[courseSlug]()
  }
  if (courseName === SAT_PREP_COURSE) {
    return isSubheader ? (
      <>Community-led SAT{hideSuperscript ? '' : <sup>&#174;</sup>} Prep</>
    ) : (
      <>Free SAT{hideSuperscript ? '' : <sup>&#174;</sup>} Prep Courses and Tutoring</>
    )
  }
  if (domain === OTHER_DOMAIN) {
    return courseName
  }
  return `${courseName} Tutoring Sessions`
}
